import { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import {
  ResponsiveFormLabel,
  ResponsiveOutlinedInput,
} from "./StyledComponents";
import axiosInstance from "../../helpers/axios";
import moment from "moment";
import CreateProduct from "./CreateProduct/createProduct";
import fieldConfig from './fieldConfig';
import AddProducts from "../Products/AddProducts";
import plus from "../../assets/images/plus_icon.png";

export default function Reducing({ mode }) {
  const nextMonthFormatted = new Date(
    new Date().setMonth(new Date().getMonth() + 1)
  )
    .toISOString()
    .split("T")[0];

  const todayFormatted = new Date().toISOString().split("T")[0];

  const [errors, setErrors] = useState({});
  const [frequency, setFrequency] = useState("Monthly");
  const [daysConvention, setDaysConvention] = useState(360);
  const [principal, setPrincipal] = useState("");
  const [tenure, setTenure] = useState("");
  const [roi, setRoi] = useState();
  const[flatInterestType,setFlatInterestType]=useState(false);
  const [startDate, setStartDate] = useState(todayFormatted);
  const [repaymentDate, setRepaymentDate] = useState(nextMonthFormatted);
  const [includeBPI, setIncludeBPI] = useState(true);
  const [detectBroken, setDetectBroken] = useState(false);
  const [addBrokenToFirstEmi, setAddBrokenToFirstEmi] = useState(detectBroken===false?true:false);
  const [insurence, setInsurence] = useState("");
  const [documentationCharges, setDocumentationCharges] = useState("");
  const [showResult, setShowResult] = useState(false);
  const [apiResponsive, setApiResponse] = useState("");
  const [pfType, setPftype] = useState("Percentage");
  const [pfTypeValue, setPfTypeValue] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [minGapDays, setMinGapDays] = useState(15);
  const user = null;
  const [openDialog, setOpenDialog] = useState(false);
  const advanceEMIArray = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const [advanceEMIValue, setAdvanceEMI] = useState(0);
   const [flateRate, setFlateRate] = useState(false);
   const [formOpen, setFormOpen] = useState(false);
  const config = fieldConfig[mode];
  // const allFieldsFilled =
  //   principal && tenure && roi && pfTypeValue;




  // processing fee amount: if percentage, divide by 100
  const flatCalculation =
    pfType === "Percentage"
      ? Number(((principal * Number(pfTypeValue || 0)) / 100).toFixed(2))
      : Number(pfTypeValue || 0);

  // 
  //     : parseFloat(pfTypeValue || 0) + parseFloat(documentationCharges || 0),
  //   "efrdvfsbrf"
  // );


  useEffect(() => {
  setFrequency("Monthly");
  setDaysConvention(360);
  setPrincipal("");
  setTenure("");
  setRoi('');
  setStartDate(todayFormatted);
  setRepaymentDate(nextMonthFormatted);
  setIncludeBPI(true);
  setDetectBroken(false);
  setAddBrokenToFirstEmi(detectBroken===false?true:false);
  setInsurence("");
  setDocumentationCharges("");
  setShowResult(false);
  setApiResponse("");
  setPftype("Percentage");
  setPfTypeValue(0);
  setTableData([]);
  setIsLoading(false);
  setMinGapDays(15);
  setOpenDialog(false);
  setAdvanceEMI(0);
  setFlateRate(false)
  setErrors({});
  setFlatInterestType(false);
}, [mode]); 


useEffect(() => {
  if (detectBroken === true) {
    setAddBrokenToFirstEmi(false); 
  } else if (detectBroken === false) {
    setAddBrokenToFirstEmi(true); 
  }
}, [detectBroken]);

  const handleClearAll = () => {
    setPrincipal("");
    setTenure("");
    setRoi("");
    setStartDate(todayFormatted);
    setRepaymentDate(nextMonthFormatted);
    setPfTypeValue(0);
    setShowResult(false);
    setInsurence("");
    setDocumentationCharges("");
    setAdvanceEMI(0);
    setErrors({});
    setFlatInterestType(false);
    setDetectBroken(false)
    setIncludeBPI(true) 
    
  };

  const formattedDate = moment(startDate, "YYYY-MM-DD").format("DD-MM-YYYY");
  const formatedrepayemntdate = moment(repaymentDate, "YYYY-MM-DD").format(
    "DD-MM-YYYY"
  );

  const pFGst = Number(
    ((flatCalculation + parseFloat(documentationCharges || 0)) * 0.18).toFixed(
      2
    )
  );

  const handleSubmit = () => {
    let formErrors = {};
    // Check if all fields are filled
    if (!frequency) formErrors.frequency = "Frequency is required.";
    if (!daysConvention)
      formErrors.daysConvention = "Days convention is required.";
    if (!principal) formErrors.principal = "Principal is required.";
    if (mode !== 'Bullet' &&!tenure) formErrors.tenure = "Tenure is required.";
    if (!roi || roi <= 0) {
      formErrors.roi = "Rate of Interest  is required.";
    }
    if (pfTypeValue === "") formErrors.pfTypeValue = "PF Type is required.";
   if (mode === 'Subvention'  && advanceEMIValue === null) {
          formErrors.advanceEMIValue = "Select advance EMIs.";
        }
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };




      const flatInterestCalculation= flatInterestType === true ? tenure > 0 ? parseFloat(((roi / tenure) * 12).toFixed(2)) : "" : isNaN(Number(roi)) ? "": parseFloat(Number(roi).toFixed(2))

 const handleGenerateSchedule = async () => {
  if (handleSubmit()) {
    setIsLoading(true);
    let apiEndpoint = "/apr";
    let payload ={};
    if (mode === "flat") {
      apiEndpoint = "/apr-simulator/generate-for-flat";
      payload = {
      frequency: frequency,
      daysConversion: daysConvention,
      principalAmount: principal,
      tenureMonths: tenure,
      interestRatePercent:flatInterestCalculation,
      interestStartDate: formattedDate,
      repaymentStartDate: formatedrepayemntdate,
      brokenPeriodInterest: includeBPI,
      deductBroken: detectBroken,
      addBrokenToFirstEmi: addBrokenToFirstEmi,
      brokenMinDays: 30,
      processingFee: flatCalculation,
      pfGst: pFGst,
      insurance: insurence ? insurence : 0,
      documentationCharges: documentationCharges ? documentationCharges : 0,
      showLog: false,
      minGapDays: minGapDays ? minGapDays : 0,
      brokenInterest:includeBPI===true?1:0,
      advanceEmi: advanceEMIValue ? advanceEMIValue : 0
    };
    } else if (mode === "basic") {
      apiEndpoint = "/apr-simulator/generate";
        payload = {
      frequency: frequency,
      daysConversion: daysConvention,
      principalAmount: principal,
      tenureMonths: tenure,
      interestRatePercent: isNaN(Number(roi))
        ? ""
        : parseFloat(Number(roi).toFixed(2)),
      interestStartDate: formattedDate,
      repaymentStartDate: formatedrepayemntdate,
      brokenPeriodInterest: includeBPI,
      deductBroken: detectBroken,
      addBrokenToFirstEmi: addBrokenToFirstEmi,
      brokenMinDays: 30,
      processingFee: flatCalculation,
      pfGst: pFGst,
      insurance: insurence ? insurence : 0,
      documentationCharges: documentationCharges ? documentationCharges : 0,
      showLog: false,
      minGapDays: minGapDays ? minGapDays : 0,
      brokenInterest:includeBPI===true?1:0,
      advanceEmi:advanceEMIValue
    };
    }else if (mode==='Interest'){
       apiEndpoint = "/apr-simulator/generate-interest-only";
        payload = {
        principalAmount: principal,
        interestRatePercent: isNaN(Number(roi))
          ? ""
          : parseFloat(Number(roi).toFixed(2)),
        interestStartDate: formattedDate,
        repaymentDate: formatedrepayemntdate,
        tenureMonths: tenure,
        processingFee: flatCalculation,
        insurance: insurence ? insurence : 0,
        pFGst: pFGst,
        deductBroken: detectBroken,
        calculateBrokenInterest: includeBPI,
        runMode: "monthly-interest",
        useActualDays: daysConvention === 365 ? true : false,
        useFutureValueMethod: false,
        showLogs: false,
        brokenMinDays: 30,
        documentationCharges: documentationCharges ? documentationCharges : 0,
        advanceEmi:advanceEMIValue
      };
    }
    else if (mode==='Bullet'){
       apiEndpoint = "/apr-simulator/generate-interest-only";
        payload = {
        principalAmount: principal,
        interestRatePercent: isNaN(Number(roi))
          ? ""
          : parseFloat(Number(roi).toFixed(2)),
        interestStartDate: formattedDate,
        repaymentDate: formatedrepayemntdate,
        tenureMonths: 6,
        processingFee: flatCalculation,
        insurance: insurence ? insurence : 0,
        pFGst: pFGst,
        deductBroken: detectBroken,
        calculateBrokenInterest: includeBPI,
        runMode: "bullet",
        useActualDays: daysConvention === 365 ? true : false,
        useFutureValueMethod: false,
        showLogs: false,
        brokenMinDays: 30,
        documentationCharges: documentationCharges ? documentationCharges : 0,
        advanceEmi:advanceEMIValue
      };
    } else if (mode==='Subvention'){
       apiEndpoint = "/apr-simulator/generate-for-subvention";
        payload = {
        principalAmount: principal,
        interestRatePercent: isNaN(Number(roi))
          ? ""
          : parseFloat(Number(roi).toFixed(2)),
        repaymentStartDate: repaymentDate,
        tenureMonths: tenure,
        processingFee: flatCalculation,
        insurance: insurence ? insurence : 0,
        pFGst: pFGst,
        showLog: false,
        flatRateIsAnnual: flateRate,
        advanceEmi: advanceEMIValue ? advanceEMIValue : 0,
        documentationCharges: documentationCharges ? documentationCharges : 0,
      };
    }


    axiosInstance
      .post(apiEndpoint, payload, {
        headers: {
        },
      })
          .then((response) => {
        if (mode === 'Bullet' || mode === 'Interest') {
          setTableData(response?.data?.data?.schedule);
          setApiResponse(response?.data?.data);
        } else {
          setTableData(response?.data?.data?.emiSchedule);
          setApiResponse(response?.data?.data);
        }

        setShowResult(true);
        setTimeout(() => {
          setIsLoading(false);
        }, 300);
      })
      .catch((error) => {
        if (error.response) {
          alert(
            `Please contact support team. Error ${error.response.status}: ${error.response.statusText}`
          );
        } else {
          alert("Unknown error occurred.");
        }
        setIsLoading(false);
      });
  } else {
    alert("Incomplete information given. Please check the details.");
    setIsLoading(false);
  }
};


  let formErrors = {};

  function formatNumberWithCommas(number) {
    const num = Number(number); // Convert to number safely
    return isNaN(num) ? "-" : num.toLocaleString("en-IN");
  }

  const handleCreateProduct = () => {
    setOpenDialog(true);
  };
   const handleCreateProductForm = () => {
    setFormOpen(true);
  };


  

  return (
    <Box p={4}>
      <Grid container spacing={2} wrap="wrap">
        {config.Frequency && (<>
        <Grid item xs={12} md={6}>
          <FormControl component="fieldset">
            <ResponsiveFormLabel component="legend">
              Frequency
            </ResponsiveFormLabel>
            <RadioGroup
              row
              value={frequency}
              onChange={(e) => setFrequency(e.target.value)}
              style={{
                borderColor: formErrors.daysConvention ? "red" : "initial",
              }}
            >
              {["daily", "Monthly", "quarterly", "bi-annually", "annually"].map(
                (opt) => (
                  <FormControlLabel
                    key={opt}
                    value={opt}
                    control={<Radio />}
                    label={opt.charAt(0).toUpperCase() + opt.slice(1)}
                    disabled={opt !== "Monthly"}
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontFamily: "Outfit",
                        fontWeight: "bold",
                      },
                    }}
                  />
                )
              )}
            </RadioGroup>
          </FormControl>
        </Grid>
         </>)}
         {config.flatInterestType && (<>
          <Grid item xs={12} md={3}>
                     <FormControl component="fieldset">
                       <ResponsiveFormLabel component="legend">
                         Flat Interest Type
                       </ResponsiveFormLabel>
                       <RadioGroup
                         row
                         value={flatInterestType}
                         onChange={(e) => setFlatInterestType(e.target.value === "true")}
                       >
                         <FormControlLabel value="true" control={<Radio />} label="Per Tenure" />
                         <FormControlLabel value="false" control={<Radio />} label="Annual" />
                       </RadioGroup>
                     </FormControl>
                </Grid>
                </>)}

          {config.daysConversion && (<>
        <Grid item xs={12} md={mode==='flat'?3:6}>
          <FormControl component="fieldset">
            <ResponsiveFormLabel component="legend">
              Days Conversion
            </ResponsiveFormLabel>
            <RadioGroup
              row
              value={daysConvention.toString()} // Ensure the current value is string
              onChange={(e) => {
                const value = e.target.value;
                setDaysConvention(value === "" ? "" : Number(value));
              }}
            >
              <FormControlLabel
                value="360"
                control={<Radio />}
                label="360"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontFamily: "Outfit",
                    fontWeight: "bold",
                  },
                }}
              />
              <FormControlLabel
                value="365"
                control={<Radio />}
                label="365"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontFamily: "Outfit",
                    fontWeight: "bold",
                  },
                }}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
          </>)}
        <Grid item xs={12} md={3}>
          <ResponsiveFormLabel>Principal Amount(₹)</ResponsiveFormLabel>
          <ResponsiveOutlinedInput
            type="number"
            value={principal}
            onChange={(e) => {
              const value = e.target.value;
              setPrincipal(value === "" ? "" : Number(value));
            }}
            error={!!errors.principal}
            helperText={errors.principal}
            placeholder="e.g. 10000"
            startAdornment={<InputAdornment position="start">₹</InputAdornment>}
            style={{
              borderColor: formErrors.principal ? "red" : "initial",
            }}
            onWheel={(e) => e.target.blur()}
          />
          {errors.principal && (
            <FormHelperText
              sx={{ color: "red", mt: "-12px", fontFamily: "Outfit" }}
            >
              {errors.principal}
            </FormHelperText>
          )}
        </Grid>
     {config.tenure && (<>
        <Grid item xs={12} md={3}>
          <ResponsiveFormLabel>Tenure (Months)</ResponsiveFormLabel>
          <ResponsiveOutlinedInput
            type="number"
            value={tenure}
            onChange={(e) => {
              const value = e.target.value;
              setTenure(value === "" ? "" : Number(value));
            }}
            placeholder="e.g. 10"
            error={!!errors.tenure}
            helperText={errors.tenure}
            onWheel={(e) => e.target.blur()}
          />
          {errors.tenure && (
            <FormHelperText
              sx={{ color: "red", mt: "-12px", fontFamily: "Outfit" }}
            >
              {errors.tenure}
            </FormHelperText>
          )}
        </Grid>
       </>)}

   
        <Grid item xs={12} md={3}>
          <ResponsiveFormLabel>ROI (%)</ResponsiveFormLabel>
          <ResponsiveOutlinedInput
            type="number"
            value={roi}
            onChange={(e) => {
              const value = e.target.value;
              setRoi(value === "" ? "" : parseFloat(Number(value).toFixed(2)));
            }}
            placeholder="e.g. 10.55"
            error={!!errors.roi}
            helperText={errors.roi}
            endAdornment={<InputAdornment position="end">%</InputAdornment>}
            onWheel={(e) => e.target.blur()}
          />
          {errors.roi && (
            <FormHelperText
              sx={{ color: "red", mt: "-12px", fontFamily: "Outfit" }}
            >
              {errors.roi}
            </FormHelperText>
          )}
        </Grid>
       

       {config.interestStartDate && (<>
        <Grid item xs={12} md={3}>
          <ResponsiveFormLabel>Interest Start Date</ResponsiveFormLabel>
          <ResponsiveOutlinedInput
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            fullWidth
          />
        </Grid>
         </>)}

        <Grid item xs={12} md={3}>
          <ResponsiveFormLabel>{mode === 'Bullete' || mode === 'Subvention' ? 'Payment Date' : 'Repayment Start Date'}</ResponsiveFormLabel>
          <ResponsiveOutlinedInput
            type="date"
            value={repaymentDate}
            onChange={(e) => setRepaymentDate(e.target.value)}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <ResponsiveFormLabel> Documentation Charges (₹)</ResponsiveFormLabel>
          <ResponsiveOutlinedInput
            type="text"
            value={documentationCharges || 0}
            //  error={!!errors.documentationCharges}
            //  helperText={errors.documentationCharges}
            onChange={(e) => {
              const value = e.target.value;
              setDocumentationCharges(value === "" ? "" : Number(value));
            }}
            onWheel={(e) => e.target.blur()}
            placeholder="e.g. 10000"
            startAdornment={<InputAdornment position="start">₹</InputAdornment>}
          />
          {/* {errors.documentationCharges && (
                                       <FormHelperText sx={{ color: "red" }}>
                                         {errors.documentationCharges  }
                                       </FormHelperText>)} */}
        </Grid>

        <Grid item xs={12} md={3}>
          <ResponsiveFormLabel> Gst (₹)</ResponsiveFormLabel>
          <ResponsiveOutlinedInput
            error={!!errors.pFGst}
            type="number"
            value={pFGst}
            placeholder="e.g. 10000"
            startAdornment={<InputAdornment position="start">₹</InputAdornment>}
            inputProps={{ readOnly: true }}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <ResponsiveFormLabel>Insurance (₹)</ResponsiveFormLabel>
          <ResponsiveOutlinedInput
            type="text"
            value={insurence || 0}
            onChange={(e) => {
              const value = e.target.value;
              setInsurence(value === "" ? "" : Number(value));
            }}
            onWheel={(e) => e.target.blur()}
            // error={!!errors.insurance}
            // helperText={errors.insurance}
            placeholder="e.g. 10000"
            startAdornment={<InputAdornment position="start">₹</InputAdornment>}
          />
          {/* {errors.insurance && (
                                      <FormHelperText sx={{ color: "red" }}>
                                        {errors.insurance  }
                                      </FormHelperText>)} */}
        </Grid>
         
       
          {config.minGapDays && (
           <>
          <Grid item xs={12} md={3} sx={{ width: "13em" }}>
            <ResponsiveFormLabel> MinGAPDays </ResponsiveFormLabel>
            <ResponsiveOutlinedInput
              type="number"
              value={minGapDays}
              disabled
              onChange={(e) => {
                const value = e.target.value;
                setMinGapDays(value === "" ? "" : Number(value));
              }}
              onWheel={(e) => e.target.blur()}
              placeholder="e.g. 10000"
            />
          </Grid>
          </>)} 

           {config.flatRateIsAnnual &&(<>
            <Grid item xs={12} md={3}>
                     <FormControl component="fieldset">
                       <ResponsiveFormLabel component="legend">
                         Flat Rate Is Annual
                       </ResponsiveFormLabel>
                       <RadioGroup
                         row
                         value={flateRate}
                         onChange={(e) => setFlateRate(e.target.value === "true")}
                       >
                         <FormControlLabel value="true" control={<Radio />} label="Yes" />
                         <FormControlLabel value="false" control={<Radio />} label="No" />
                       </RadioGroup>
                     </FormControl>
                </Grid>
             </>)}

          <Grid
            item
            xs={12}
            md={3}
            component="fieldset"
            sx={{ fontFamily: "Outfit" }}
          >
            <ResponsiveFormLabel>PF Type</ResponsiveFormLabel>

            <RadioGroup
              row
              value={pfType}
              onChange={(e) => setPftype(e.target.value)}
            >
              {["Flat", "Percentage"].map((type) => (
                <FormControlLabel
                  key={type}
                  value={type}
                  control={<Radio />}
                  label={type}
                  sx={{
                    fontFamily: "Outfit",
                    marginRight: "1em",
                    "& .MuiFormControlLabel-label": {
                      fontFamily: "Outfit",
                      fontWeight: "bold",
                    },
                  }}
                />
              ))}
            </RadioGroup>
          </Grid>

          <Grid
            item
            xs={12}
            md={3}
            component="fieldset"
           sx={{
              alignSelf: "center"}}
          >
            <ResponsiveFormLabel>
              {pfType === "Percentage" ? "PF Percentage" : "PF Value"}
            </ResponsiveFormLabel>
            <ResponsiveOutlinedInput
              startAdornment={
                pfType !== "Percentage" && (
                  <InputAdornment position="start">₹</InputAdornment>
                )
              }
              endAdornment={
                pfType === "Percentage" && (
                  <InputAdornment position="end">%</InputAdornment>
                )
              }
              type="number"
              value={pfTypeValue}
              onWheel={(e) => e.target.blur()}
              error={!!errors.pfTypeValue}
              helperText={errors.pfTypeValue}
              onChange={(e) => {
                const input = e.target.value;
                if (
                  input === "" ||
                  input === "0" ||
                  input === "0." ||
                  input === "0.0"
                ) {
                  setPfTypeValue(input);
                  return;
                }

                const numericValue = parseFloat(parseFloat(input).toFixed(2));

                // ✅ Check if the value is less than 0; if yes, ignore it
                if (numericValue < 0) {
                  return;
                }

                if (pfType === "Percentage") {
                  setPfTypeValue(isNaN(numericValue) ? "" : numericValue);
                } else {
                  setPfTypeValue(input);
                }
              }}
            />
            {errors.pfTypeValue && (
              <FormHelperText
                sx={{ color: "red", mt: "-12px", fontFamily: "Outfit" }}
              >
                {errors.pfTypeValue}
              </FormHelperText>
            )}
          </Grid>
          {config.advanceEMIs &&(<>
           <Grid item xs={12} md={3} component="fieldset">
            <ResponsiveFormLabel>Advance EMIs</ResponsiveFormLabel>
            <Autocomplete
              options={advanceEMIArray}
              value={advanceEMIValue}
              onChange={(e, value) => setAdvanceEMI(value)}
              disableClearable
              // disabled={mode !== "Subvention"}
              sx={{
                "& .MuiPopper-root": {
                  fontFamily: "Outfit",
                  border: "2px solid #bfbfbf",
                },
                fontWeight: "300",
              }}
              size="small"
              renderInput={(params) => (
                <TextField
                  error={!!errors.advanceEMIValue}
                  helperText={errors.advanceEMIValue}
                  FormHelperTextProps={{
                    sx: {
                      fontFamily: "Outfit",
                      fontSize: "13px", // optional
                    },
                  }}
                  {...params}
                  placeholder="Select EMI"
                  InputLabelProps={{
                    sx: {
                      fontFamily: "Outfit",
                      borderRadius: "5px",
                      fontSize: "14px",
                    },
                  }}
                  sx={{
                    fontFamily: "Outfit",

                    "& .MuiOutlinedInput-root": {
                      fontFamily: "Outfit",

                      "& fieldset": {
                        border: "2px solid  #bfbfbf",
                      },
                      "&:hover fieldset": {
                        borderColor: "#707C8B",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#d32028",
                      },
                      "& .MuiInputLabel-root": {
                        fontFamily: "Outfit",
                        fontWeight: "300",
                        fontSize: "14px",
                      },
                      "& .MuiOutlinedInput-input": {
                        fontFamily: "Outfit",
                        fontWeight: "bold",
                      },
                    },
                  }}
                />
              )}
            />
          </Grid>
          </>)}
         
      
          {config.brokenPeriodInterest &&(<>
          <Grid item xs={12} md={3} >
         <FormControl component="fieldset">
            <ResponsiveFormLabel component="legend">
              Broken Period Interest 
            </ResponsiveFormLabel>
            <RadioGroup
              row
              value={includeBPI}
              onChange={(e) => setIncludeBPI(e.target.value === "true")}
            >
              <FormControlLabel
                value="true"
                control={<Radio />}
                label="Yes"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontFamily: "Outfit",
                    fontWeight: "bold",
                  },
                }}
              />
              <FormControlLabel
                value="false"
                control={<Radio />}
                label="No"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontFamily: "Outfit",
                    fontWeight: "bold",
                  },
                }}
              />
            </RadioGroup>
         </FormControl>
           </Grid>
              </>)}
            {config.deductBroken &&(<>
            <Grid item xs={12} md={3}>
          <FormControl component="fieldset">
            <ResponsiveFormLabel component="legend">
              Deduct Broken
            </ResponsiveFormLabel>
            <RadioGroup
              row
              value={detectBroken}
              onChange={(e) => setDetectBroken(e.target.value === "true")}
            >
              <FormControlLabel
                value="true"
                control={<Radio />}
                label="Yes"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontFamily: "Outfit",
                    fontWeight: "bold",
                  },
                }}
              />
              <FormControlLabel
                value="false"
                control={<Radio />}
                label="No"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontFamily: "Outfit",
                    fontWeight: "bold",
                  },
                }}
              />
            </RadioGroup>
          </FormControl>
          </Grid>
           </>)}
           {config.addBrokenToFirstEmi &&(<>
          
          <Grid item xs={12} md={3}>
          <FormControl component="fieldset">
          <ResponsiveFormLabel component="legend">
            Add Broken To FirstEmi
          </ResponsiveFormLabel>
          <RadioGroup
            row
            value={addBrokenToFirstEmi.toString()}
            onChange={(e) =>
              setAddBrokenToFirstEmi(e.target.value === "true")
            }
          >
            <FormControlLabel
              value="true"
              control={<Radio />}
              label="Yes"
              disabled
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontFamily: "Outfit",
                  fontWeight: "bold",
                },
              }}
            />
            <FormControlLabel
              value="false"
              control={<Radio />}
              label="No"
              disabled
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontFamily: "Outfit",
                  fontWeight: "bold",
                },
              }}
            />
          </RadioGroup>
        </FormControl>
          </Grid>
           </>)}

       

        <Grid item xs={12} display="flex" gap={2}>
          <Button
            variant="outlined"
            sx={{
              color: "#d32f2f",
              fontFamily: "Outfit",
              fontWeight: "bold",
              textTransform: "none",
            }}
            onClick={handleClearAll}
          >
            Clear All
          </Button>
          <Button
            sx={{
              // bgcolor: !allFieldsFilled ? "#d32f2f" : "blue",
              bgcolor:'#d4242c',
              color: "white",
              fontFamily: "Outfit",
              fontWeight: "bold",
              textTransform: "none",
            }}
            variant="contained"
            onClick={async () => handleGenerateSchedule()}
          >
            Generate Schedule
          </Button>
         {showResult && (mode === "basic" || mode === "flat") && (
          
              <Button
                variant="contained"
                sx={{
                  bgcolor: "#d32f2f",
                  color: "white",
                  fontWeight: "bold",
                  fontFamily: "Outfit",
                  alignSelf: "flex-end",
                  textTransform: "none",
                }}
                onClick={handleCreateProduct}
              >
                Create Product
              </Button>
            )}

           

          <CreateProduct
            roi={roi}
            includeBPI={includeBPI}
            deductBroken={detectBroken}
            addBrokenToFirstEmi={addBrokenToFirstEmi}
            frequency={frequency}
            daysConversion={daysConvention}
            pfType={pfType}
            pfTypeValue={pfTypeValue}
            productCategory={"Standard EMI"}
            mode ={mode}
            setOpenDialog={setOpenDialog}
            openDialog={openDialog}
            FlateRate={flateRate}
            advanceEMIs={advanceEMIValue}
            apr={Number(apiResponsive?.aprIRR).toFixed(2)}
            flatInterestCalculation={flatInterestCalculation}
            flatInterestType={flatInterestType}
            tenure={tenure}
            
          />
       
                {mode === "Subvention" && showResult && Array.isArray(tableData) && (
              <Button
                variant="contained"
                sx={{
                  bgcolor: "#d32f2f",
                  color: "white",
                  fontWeight: "bold",
                  fontFamily: "Outfit",
                  alignSelf: "flex-end",
                  textTransform: "none",
                }}
                 onClick={handleCreateProductForm}
                >
                  <img src={plus} style={{marginRight:'10px'}} alt=""/> Add Product
                <AddProducts
                  Roi={roi}
                  Tenure={tenure}
                  PfType={pfType}
                  PfTypeValue={pfTypeValue}
                  advance={advanceEMIValue}
                  FlateRate={flateRate}
                   setOpenDialog={setFormOpen}
                  productCategory="Subvention GST"
                  openDialog={formOpen}
                />
            </Button>
            )}
      



        </Grid>

        {showResult && Array.isArray(tableData) && (
          <>
            {!isLoading ? (
              <>
              

                

                {(mode === "basic" || mode === "flat" || mode === "Subvention" )  && (
                  <>
                   <Box
                  mt={4}
                  display="flex"
                  flexWrap="nowrap"
                  gap={2}
                  alignItems="center"
                >
                  <Paper elevation={3} sx={{ p: 1.5, border: "2px solid red" }}>
                    Principal : ₹{" "}
                    {formatNumberWithCommas(
                        Math.floor(apiResponsive?.totals?.totalprinciple ?? apiResponsive?.totals?.totalPrincipal ?? 0)
                      )}
                  </Paper>
                  <Paper
                    elevation={3}
                    sx={{ p: 1.5, border: "2px solid blue" }}
                  >
                    Repayment : ₹{" "}
                    {formatNumberWithCommas(
                      Math.floor(apiResponsive?.totals?.totalInstallment || "-")
                    )}
                  </Paper>
                  <Paper
                    elevation={3}
                    sx={{ p: 1.5, border: "2px solid green" }}
                  >
                    Interest : ₹{" "}
                    {formatNumberWithCommas(
                      Math.floor(apiResponsive?.totals?.totalInterest || "-")
                    )}
                  </Paper>
                  <Paper
                    elevation={3}
                    sx={{ p: 1.5, border: "2px solid brown" }}
                  >
                    APR:{" "}
                    {apiResponsive?.aprIRR
                      ? Number(apiResponsive?.aprIRR).toFixed(2)
                      : "-"}
                  </Paper>
                  <Paper
                    elevation={3}
                    sx={{ p: 1.5, border: "2px solid green" }}
                  >
                    Disbursement : ₹{" "}
                    {formatNumberWithCommas(
                      Math.floor(apiResponsive?.netDisbursement || "-")
                    )}
                  </Paper>
                </Box>

                <TableContainer component={Paper} sx={{ mt: 4 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Installment Number</TableCell>
                        <TableCell>Due Date</TableCell>
                        <TableCell>Installment Amount</TableCell>
                        <TableCell>Principal</TableCell>
                        <TableCell>Interest</TableCell>
                        <TableCell>Opening Balance</TableCell>
                        <TableCell>Closing Balance</TableCell>
                        <TableCell>type</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tableData.map((item, index) =>
                        item.amount !== 0 ? (
                          <TableRow key={index}>
                            <TableCell>{item.emiNo}</TableCell>
                            <TableCell>{item.dueDate}</TableCell>
                            <TableCell>
                              ₹{" "}
                              {item.emiAmount
                                ? formatNumberWithCommas(item.emiAmount)
                                : "0"}
                            </TableCell>
                            <TableCell>
                              ₹{" "}
                              {formatNumberWithCommas(
                                item.principle ? item.principle : "0"
                              )}
                            </TableCell>
                            <TableCell>
                              ₹{" "}
                              {item.interest
                                ? formatNumberWithCommas(item.interest)
                                : "0"}
                            </TableCell>
                            <TableCell>
                              ₹{" "}
                              {item.outstanding
                                ? formatNumberWithCommas(item.outstanding)
                                : "0"}
                            </TableCell>
                            <TableCell>
                              ₹{" "}
                              {item.closingBalance
                                ? formatNumberWithCommas(item.closingBalance)
                                : "0"}
                            </TableCell>
                            <TableCell>{item.type ? item.type : "-"}</TableCell>
                          </TableRow>
                        ) : null
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                </>
                )}
                {mode==="Interest" && (
                  <>
                     <Box
                                      mt={4}
                                      display="flex"
                                      flexWrap="nowrap"
                                      gap={2}
                                      alignItems="center"
                                    >
                                      <Paper elevation={3} sx={{ p: 2, border: "2px solid red" }}>
                                        Principal : ₹{" "}
                                        {formatNumberWithCommas(
                                          apiResponsive?.totalPrincipal || "-"
                                        )}
                                      </Paper>
                                      <Paper elevation={3} sx={{ p: 2, border: "2px solid blue" }}>
                                        Installment : ₹{" "}
                                        {formatNumberWithCommas(
                                          apiResponsive?.totalInstallment || "-"
                                        )}
                                      </Paper>
                                      <Paper elevation={3} sx={{ p: 2, border: "2px solid green" }}>
                                        Interest : ₹{" "}
                                        {formatNumberWithCommas(
                                          apiResponsive?.totalInterest || "-"
                                        )}
                                      </Paper>
                                      <Paper elevation={3} sx={{ p: 2, border: "2px solid brown" }}>
                                        APR:{" "}
                                        {apiResponsive?.aprIRR
                                          ? Number(apiResponsive?.aprIRR).toFixed(2)
                                          : "-"}
                                      </Paper>
                                      <Paper elevation={3} sx={{ p: 2, border: "2px solid green" }}>
                                        Disbursement : ₹{" "}
                                        {formatNumberWithCommas(
                                          apiResponsive?.netDisbursement || "-"
                                        )}
                                      </Paper>
                                    </Box>
                    <TableContainer component={Paper} sx={{ mt: 4 }}>
                                    <Table size="small">
                                      <TableHead>
                                        <TableRow>
                                          <TableCell>Installment Number</TableCell>
                                          <TableCell>Due Date</TableCell>
                                          <TableCell>Installment Amount</TableCell>
                                          <TableCell>Principal</TableCell>
                                          <TableCell>Interest</TableCell>
                                          <TableCell>type</TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {tableData?.map((item, index) => (
                                          <TableRow key={index}>
                                            <TableCell>{item.installment}</TableCell>
                                            <TableCell>{item.date}</TableCell>
                                            <TableCell>
                                              ₹{" "}
                                              {item.total
                                                ? formatNumberWithCommas(item.total)
                                                : "0"}
                                            </TableCell>
                                            <TableCell>
                                              ₹{" "}
                                              {formatNumberWithCommas(
                                                item.principal ? item.principal : "0"
                                              )}
                                            </TableCell>
                                            <TableCell>
                                              ₹{" "}
                                              {item.interest
                                                ? formatNumberWithCommas(item.interest)
                                                : "0"}
                                            </TableCell>
                                            <TableCell>{item.type ? item.type : "-"}</TableCell>
                                          </TableRow>
                                        ))}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                  </>
                )}
                  
                {mode==="Bullet" && (

                  <>
                    <Box
                                    mt={4}
                                    display="flex"
                                    flexWrap="nowrap"
                                    gap={2}
                                    alignItems="center"
                                  >
                                    <Paper elevation={3} sx={{ p: 2, border: "2px solid red" }}>
                                      Principal : ₹{" "}
                                      {formatNumberWithCommas(
                                        apiResponsive?.totalPrincipal || "-"
                                      )}
                                    </Paper>
                                    <Paper elevation={3} sx={{ p: 2, border: "2px solid blue" }}>
                                      Installment : ₹{" "}
                                      {formatNumberWithCommas(
                                        apiResponsive?.totalInstallment || "-"
                                      )}
                                    </Paper>
                                    <Paper elevation={3} sx={{ p: 2, border: "2px solid green" }}>
                                      Interest : ₹{" "}
                                      {formatNumberWithCommas(
                                        apiResponsive?.totalInterest || "-"
                                      )}
                                    </Paper>
                                    <Paper elevation={3} sx={{ p: 2, border: "2px solid brown" }}>
                                      APR:{" "}
                                      {apiResponsive?.aprIRR
                                        ? Number(apiResponsive?.aprIRR).toFixed(2)
                                        : "-"}
                                    </Paper>
                                    <Paper elevation={3} sx={{ p: 2, border: "2px solid green" }}>
                                      Disbursement : ₹{" "}
                                      {formatNumberWithCommas(
                                        apiResponsive?.netDisbursement || "-"
                                      )}
                                    </Paper>
                                    {/* <Button style={{marginLeft:'30px'}}><AddProducts  Tenure={tenure} Roi={roi} IncludeBPI={includeBPI} DetectBroken={detectBroken} AddBrokenToFirstEmi={addBrokenToFirstEmi} Frequency={frequency} DaysConvention={daysConvention}  PfType ={pfType} PfTypeValue ={pfTypeValue} /></Button> */}
                                  </Box>

                     <TableContainer component={Paper} sx={{ mt: 4 }}>
                                      <Table size="small">
                                        <TableHead>
                                          <TableRow>
                                            <TableCell>Due Date</TableCell>
                                            <TableCell>Days</TableCell>
                                            <TableCell>Total</TableCell>
                                            <TableCell>Principal</TableCell>
                                            <TableCell>Interest</TableCell>
                                            <TableCell>type</TableCell>
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {tableData?.map((item, index) => (
                                            <TableRow key={index}>
                                              <TableCell>{item.date}</TableCell>
                                              <TableCell> {item.days ? item.days : "0"}</TableCell>
                                              <TableCell>
                                                ₹{" "}
                                                {item.total
                                                  ? formatNumberWithCommas(item.total)
                                                  : "0"}
                                              </TableCell>
                                              <TableCell>
                                                ₹{" "}
                                                {formatNumberWithCommas(
                                                  item.principal ? item.principal : "0"
                                                )}
                                              </TableCell>
                                              <TableCell>
                                                ₹{" "}
                                                {item.interest
                                                  ? formatNumberWithCommas(item.interest)
                                                  : "0"}
                                              </TableCell>
                                              <TableCell>₹ {item.type ? item.type : "-"}</TableCell>
                                            </TableRow>
                                          ))}
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                       </>
                )} 

           

              </>
            ) : (
              <Typography mt={4} align="center">
                Loading...
              </Typography>
            )}
          </>
        )}
      </Grid>
    </Box>
  );
}
